import {StringCollapserController} from './string-collapser.controller';

export default class StringCollapserComponent {
    public static componentName = 'kpStringCollapser';

    public templateUrl = require('./kp-string-collapser.tpl.ftl');
    public transclude = true;
    public bindings = {
        value: '=',
        charactersLimit: '@'
    };
    public controller = StringCollapserController;
}
